import { motion } from "framer-motion";
import { ROLE_DATA } from "../../data/roles.js";
import { slideLeft } from "../../animations/variants.js";
import { NightPanel } from "../ui/Panel.jsx";

export function NightRoleWrapper({ roleId, children, t }) {
  const role = ROLE_DATA[roleId];
  return (
    <motion.div variants={slideLeft} initial="initial" animate="animate" exit="exit"
      className="flex flex-col gap-4">
      <div className={`flex items-center gap-3 rounded-2xl p-3 bg-gradient-to-r ${role?.gradient} border ${role?.border}`}>
        <span className="text-3xl">{role?.emoji}</span>
        <div>
          <p className="text-white/40 text-[10px] uppercase tracking-widest">
            {t("Réveillez","Wake up")}
          </p>
          <p className="text-white font-bold text-base">
            {t(role?.frenchName, role?.englishName)}
          </p>
        </div>
      </div>
      {children}
    </motion.div>
  );
}
